import { validateEmail } from "utils/validate";

export function validateName(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return null;
}

export function validatePhoneNumber(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return null;
}

export function validateCountry(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return null;
}

export function validateState(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }
    return null;
}

export function validateEmailInput(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }

    if (!validateEmail(value)) {
        return "Invalid email";
    }
    return null;
}

export function validateGstinInput(value: string | undefined | null): string | undefined | null {
    if (!value || value.length < 1) {
        return "Fill field";
    }

    return null;
}

export function validateCountArtist(value: string | undefined | null): string | undefined | null {
    if (value && value.length > 0) {
        const numCount = Number(value);

        if (!Number.isInteger(numCount)) {
            return "Must fill is number";
        }

        if (numCount < 1) {
            return "Must > 0";
        }
    }

    return null;
}